import { render, staticRenderFns } from "./popovers.vue.js?vue&type=template&id=5d185cf1!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./popovers.vue?vue&type=template&id=5d185cf1"
import script from "./popovers.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./popovers.vue?vue&type=script&lang=js"
export * from "./popovers.vue.js?vue&type=script&lang=js!=!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./popovers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports